/* eslint-disable jsx-a11y/anchor-is-valid */
import { globalVariables } from "helper/globalVariables";
import { useMediaQuery } from "react-responsive";
export const TrialDetailCard = ({ trailDrawDetail }) => {
  const isSmallMobile = useMediaQuery({ query: "(max-width: 320px)" });

  return (
    <div class={`bg-white ${isSmallMobile ? "w-70 pb-2" : "w-80"}`}>
      <div class="flex justify-start flex-col mt-5 pb-3">
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.memberName}
          </span>
          <span className="text-md">{trailDrawDetail.memberName}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.dogName}
          </span>
          <span className="text-md">{trailDrawDetail.dog}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.phoneNumber}
          </span>
          <span className="text-md">{trailDrawDetail.phoneNumber}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">{globalVariables.email}</span>
          <span className="text-md">{trailDrawDetail.email}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.address}
          </span>
          <span className="text-md">{trailDrawDetail.address}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.emergencyContactNameCap}
          </span>
          <span className="text-md">
            {trailDrawDetail.emergencyContactName}
          </span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.emergencyContactNumberCap}
          </span>
          <span className="text-md">
            {trailDrawDetail.emergencyContactNumber}
          </span>
        </div>
      </div>
    </div>
  );
};
